import React from "react";
import "./home.css";
import HeroSection from "./HeroSection";
import HomeCarousel from "./HomeCarousel";
import NewsletterSection from "./NewsletterSection";
import GetAppSection from "./GetAppSection";
import CommunitySection from "./CommunitySection";
import HomeJobListings from "./HomeJobListings";
import HomeBrowseJobs from "./HomeBrowseJobs";
import SeoHead from "../../Common/SeoHead";
import { PAGE_SEO, SITELINK_PAGES, absoluteUrl } from "../../../constants/seo";
import { buildOrganizationJsonLd, buildWebSiteJsonLd } from "../../../Helper/structuredData";

const Home = () => {
  const homeSeo = PAGE_SEO["/"];

  return (
    <div className="home-container">
      <SeoHead
        title={homeSeo.title}
        description={homeSeo.description}
        path="/"
        jsonLd={[
          buildOrganizationJsonLd(),
          buildWebSiteJsonLd(),
          {
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "CAJobPortal job categories",
            itemListElement: SITELINK_PAGES.map((item, index) => ({
              "@type": "ListItem",
              position: index + 1,
              name: item.label,
              url: absoluteUrl(item.path),
            })),
          },
        ]}
      />

      {/* Modern Hero Section */}
      <HeroSection />

      <HomeBrowseJobs />

      {/* Latest Job Openings with Pagination */}
      <HomeJobListings />

      {/* Company Logos Carousel */}
      <HomeCarousel />

      {/* Play Store App */}
      <GetAppSection />

      {/* WhatsApp Community */}
      <CommunitySection />

      {/* Newsletter Section */}
      <NewsletterSection />
    </div>
  );
};

export default Home;

